import { FieldValidator } from "./"

export const validateEmailFormat: FieldValidator = value => {
  const EMAIL_REGEXP = /.+@.+\..+/
  let error = null

  if (value && !value.match(EMAIL_REGEXP)) {
    error = `Please include an '@' in the email address. '${value}' is missing an '@'`
  }

  return error
}
